import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { SonForm } from '../../../_lib/Form2';

type CalendarDeleteForm = {
  form: SonForm<any>;
  refresh(): void;
};

export function CalendarDeleteForm({ form, refresh }: CalendarDeleteForm) {
  const { t } = useSonTranslation('Calendar');

  return (
    <AcceptDeclineForm
      form={form}
      headline={t('deleteForm.question')}
      onSuccess={refresh}
      messageSuccess={t('deleteForm.status.success')}
      messageSending={t('deleteForm.status.sending')}
      messageFail={t('deleteForm.status.fail')}
    />
  );
}
